import { createFileRoute } from "@tanstack/react-router";
import heroAsset from "@/assets/garage-cleanout-hero.webp.asset.json";
import garageBefore from "@/assets/garage-before.webp.asset.json";
import garageAfter from "@/assets/garage-after.webp.asset.json";
import garageBefore2 from "@/assets/garage-before-2.webp.asset.json";
import garageAfter2 from "@/assets/garage-after-2.webp.asset.json";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/garage-cleanouts")({
  head: () => ({
    meta: [
      { title: services["garage-cleanouts"].metaTitle },
      { name: "description", content: services["garage-cleanouts"].metaDescription },
      { property: "og:title", content: services["garage-cleanouts"].metaTitle },
      { property: "og:description", content: services["garage-cleanouts"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/garage-cleanouts" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/garage-cleanouts" }, { rel: "preload", as: "image", href: heroAsset.url, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Garage Cleanouts', url: 'https://anchorsrq.com/garage-cleanouts' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "garage-cleanouts", name: 'Garage Cleanouts', serviceType: 'Garage Cleanout', description: 'Same-day garage clear-outs across Sarasota and Manatee counties — tools, lawn equipment, furniture, and accumulated clutter sorted and hauled by Anchor Services.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["garage-cleanouts"].faqs)) },
    ],
  }),
  component: () => (
    <ServicePage
      {...services["garage-cleanouts"]}
      heroImg={heroAsset.url}
      beforeAfter={[
        {
          before: garageBefore.url,
          after: garageAfter.url,
          caption: "Two-car garage in Sarasota — cleared, sorted and swept in a single visit.",
        },
        {
          before: garageBefore2.url,
          after: garageAfter2.url,
          caption: "Single-bay garage packed wall to wall — hauled out, shelved and broom-clean the same day.",
        },
      ]}
    />
  ),
});
